import http from "../http-common";

class ClaimV2DataService {
  getAll(page = 1, size = 20, isApproved) {
    let url = `/claimV2?page=${page}&size=${size}`;
    if (isApproved !== undefined) url += `&isApproved=${isApproved}`;
    return http.get(url);
  }

  getStatusCounts() {
    return http.get("/claimV2/statusCounts");
  }
}

export default new ClaimV2DataService();
